// extracted by mini-css-extract-plugin
export default {"icon":"FooterNav_icon__nFVrc","footerNav":"FooterNav_footerNav__3fvwW","active":"FooterNav_active__nb72y"};